import { useEffect, useState } from 'react';
import { post } from 'common/utils';
import moment from 'moment';

const Hook = () => {
    const [conf, setConf] = useState(null);
    const [loading, setLoading] = useState(false);
    const [results, setResults] = useState(null);

    useEffect(() => {
        if (!!conf) {
            const { time, range, id: sys_id } = conf;
            if (typeof time !== 'string' || typeof sys_id !== 'number') {
                setResults(null);
                setLoading(null);
                return;
            };
            let requesting = true;
            setLoading(true);
            const day = moment(time).startOf(range).format("YYYY-MM-DD");
            post(process.env.REACT_APP_SERVER_PATH + 'api/alarm/get_alarm_brief_per_shift', {
                day,
                sys_id,
            })
                .then((retData) => {
                    if (requesting) {
                        setLoading(false);
                        // console.log('hook', retData);
                        if (!!retData.data && retData.data.errcode === 0) {
                            const nextResults = retData.data;

                            // console.log(nextResults);
                            setResults(nextResults);
                            return;//其他都算请求失败了
                        } else {
                            // 处理失败
                            setResults(null);
                        };
                    };
                });
            return () => {
                requesting = false;
            };
        };
    }, [conf]);
    return [results, setConf, loading];
};

export default Hook;
